
<canvas ref="weightChart"></canvas>
